<div class="main-content">
    <div class="row">
        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container mainContentNew">
                        <div class="d-flex">
                            <mat-icon  class="chat-back-button" (click)="goBack()" style="margin-right: 10px;">arrow_back</mat-icon>
                            <h4 class="text-black">CEU</h4>
                        </div>
                        <div class="d-flex justify-content-between d-none d-md-none d-lg-flex">
                            <span class="d-block" style="color: #979797; width: 70%">
                                {{ mode == 'edit' ? 'Edit' : 'Add New' }} your CEU inquiry
                            </span>
                            <ul class="breadcrumb d-none d-sm-none d-md-none d-lg-flex">
                                <li class=""><a [routerLink]="['/dashboard/home']">Home</a></li>
                                <li class="separator">/</li>
                                <li><a style="color: #979797" [routerLink]="['/my-wallet']" [queryParams]="{tab: 'ceus'}">Wallet</a></li>
                                <li class="separator">/</li>
                                <li class="active"><a style="color: #979797" href="#">CEU</a></li>
                            </ul>
                        </div>

                        <hr style="height: 1px; background: #ccc; border: none" />
                    </div>
                    <div class="container">
                        <mat-stepper #stepper linear>
                            <!-- Step 1 -->
                            <mat-step [stepControl]="firstFormGroup" label="General Information">
                                <form [formGroup]="firstFormGroup">
                                    <div class="row my-5">
                                        <div class="col-12 text-center">
                                            <h5>Step 1 General Information</h5>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-12">
                                            <mat-form-field class="full-width w-100" appearance="outline" >
                                                <mat-label>Certification</mat-label>
                                                <mat-select formControlName="certification">
                                                    <mat-option *ngFor="let cert of certifications" [value]="cert.id">
                                                        {{ cert.association.providerName + ' - ' + cert.certificationTitle }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <mat-form-field class="full-width w-100" appearance="outline" >
                                                <mat-label>Document Type</mat-label>
                                                <mat-select formControlName="documentType">
                                                    <mat-option *ngFor="let param of documentTypes.parameterMembers" [value]="param.parameterValue">
                                                        {{ param.parameterLabel }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <mat-form-field class="full-width w-100" appearance="outline" >
                                                <mat-label>Activity Type</mat-label>
                                                <mat-select formControlName="activity">
                                                    <mat-option *ngFor="let activity of activityList" [value]="activity.id">
                                                        {{ activity.activityType }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </form>
                            </mat-step>

                            <!-- Step 2 -->
                            <mat-step [stepControl]="secondFormGroup" label="Validity Check">
                                <form [formGroup]="secondFormGroup">
                                    <div class="row my-5">
                                        <div class="col-12 text-center">
                                            <h5>Validity Check</h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <app-validity-check-light
                                                    [providerActivities]="activities"
                                                    [form]="firstFormGroup"
                                                    [theme]="'light'"
                                                    [mode]="mode"
                                                    [data]="data?.document?.activityResponse"
                                                    [uploading]="uploading"
                                                    (result)="getValidationCheckResult($event)"></app-validity-check-light>
                                        </div>
                                    </div>
                                </form>
                            </mat-step>

                            <!-- Step 3 -->
                            <mat-step [stepControl]="thirdFormGroup" label="Upload Certification">
                                <form [formGroup]="thirdFormGroup">
                                    <app-upload-single
                                            (fileChange)="getFileChange($event)"
                                            [accept]="'image/*,application/pdf'"
                                            [fileUrl]="fileUrl"
                                            [labelButton]="'Browse Certificate'"
                                            [label]="'Upload Certification'" [readonly]="uploading">

                                    </app-upload-single>
                                </form>
                            </mat-step>
                        </mat-stepper>

                        <!-- Buttons outside stepper -->
                        <div class="button-container text-center mt-4" style="border-top: 1px solid #ccc; padding-top: 15px; margin-top: 15px; display: flex; justify-content: center; align-items: center; gap: 15px;">
                            <!-- Show only Next button on step 1 -->
                            <ng-container *ngIf="stepper.selectedIndex === 0">
                                <button style="width: 150px;background:#5B25B4; color: #fff;" mat-raised-button (click)="stepper.next()">Next</button>
                            </ng-container>

                            <!-- Show Previous, Reset, and Next buttons on steps 2 and 3 -->
                            <ng-container *ngIf="stepper.selectedIndex === 1">
                                <button style="width: 150px;" mat-raised-button (click)="stepper.previous()">Previous</button>
                                <button style="width: 150px;" mat-raised-button color="warn" (click)="onReset(stepper)">Reset</button>
                                <button style="width: 150px;background:#5B25B4; color: #fff;" mat-raised-button (click)="stepper.next()">Next</button>
                            </ng-container>

                            <ng-container *ngIf="stepper.selectedIndex === 2">
                                <button style="width: 150px;" mat-raised-button (click)="stepper.previous()">Previous</button>
                                <button style="width: 150px;" mat-raised-button color="warn" (click)="onReset(stepper)">Reset</button>
                                <button mat-raised-button  style="width: 150px;background:#5B25B4; color: #fff;" (click)="save()">Save</button>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>


